import { ThemeStyleProvider } from "./providers/ThemeStyleProvider";
import { AppRouter } from "./router";
import { ToastHost } from "./components/ui/ToastHost";

export function App() {
  return (
    <ThemeStyleProvider>
      <AppRouter />
      <ToastHost />
    </ThemeStyleProvider>
  );
}
